import type { ReactNode } from 'react';

import { Label, Switch } from '@shigo-ui/ui';

export interface DashboardPageFormFieldProps {
  children: ReactNode;
  error?: ReactNode | undefined;
  hint?: ReactNode | undefined;
  label: ReactNode;
  required?: boolean | undefined;
  htmlFor?: string | undefined;
}

export function DashboardPageFormField({
  children,
  error,
  hint,
  label,
  required,
  htmlFor,
}: DashboardPageFormFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label className="text-[13px] font-semibold" htmlFor={htmlFor}>
        {label} {required ? <span className="text-destructive">*</span> : null}
      </Label>
      {children}
      {error ? <p className="text-destructive text-xs">{error}</p> : null}
      {hint ? <p className="text-muted-foreground text-xs leading-relaxed">{hint}</p> : null}
    </div>
  );
}

export interface DashboardPageFormToggleSectionProps {
  checked: boolean;
  children: ReactNode;
  description?: ReactNode | undefined;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}

export function DashboardPageFormToggleSection({
  checked,
  children,
  description,
  label,
  onCheckedChange,
}: DashboardPageFormToggleSectionProps) {
  return (
    <section className="border-input grid gap-4 rounded-md border p-4">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <Label className="text-[13px] font-semibold">{label}</Label>
          {description ? (
            <p className="text-muted-foreground mt-0.5 text-xs leading-relaxed">{description}</p>
          ) : null}
        </div>
        <Switch checked={checked} onCheckedChange={onCheckedChange} aria-label={label} />
      </div>
      {checked ? children : null}
    </section>
  );
}
